import { OktaAuth } from '@okta/okta-auth-js'

export const getCurrentUserEmail = async (
  oktaAuth: OktaAuth
): Promise<string | undefined> => {
  const oktaAuthenticated = await oktaAuth.isAuthenticated()
  if (!oktaAuthenticated) {
    return
  }
  const data = (await oktaAuth.tokenManager.get('idToken')) as {
    claims: { email: string }
  }
  return data.claims.email
}
